

const IconCard = ({image, text}) => {
    return (
        <div className="flex flex-col m-4 items-center">

            <div className="mb-4 bg-[rgba(255,255,255,0.095)] rounded-[26px] w-[30vw] h-[30vw] sm:w-[100px] sm:h-[100px] lg:w-[150px] lg:h-[150px] shadow-shadowi flex justify-center items-center"
                style={{backdropFilter: 'blur(74.4293px)'}}
            >
                <img src = {image} alt = 'icon' className="max-w-[50px]" />
            </div>

            <p className="w-full text-sm lg:text-base text-white text-center max-w-[15ch]">{text}</p>

        </div>
    )   
}

export default IconCard;